export const DynamicPageContent = [
    { page: "landing", title: "First Resource", banbg: '' },
    {
        page: "about", title: "Who We Are",
        banbg: '/innerbanner/about.jpg',
        banbgmd: '/innerbanner/aboutmd.jpg',
        banbglg: '/innerbanner/aboutlg.jpg'
    },
    {
        page: "offerings", title: "Offerings",
        banbg: '/innerbanner/offering.jpg',
        banbgmd: '/innerbanner/offeringmd.jpg',
        banbglg: '/innerbanner/offeringlg.jpg'
    },
    {
        page: "domain", title: "Domains",
        banbg: '/innerbanner/domainbg.jpg',
        banbgmd: '/innerbanner/domainbgmd.jpg',
        banbglg: '/innerbanner/domainbglg.jpg'
    },
    {
        page: "contact", title: "Contact Us",
        banbg: '/innerbanner/contact.jpg',
        banbgmd: '/innerbanner/contactmd.jpg',
        banbglg: '/innerbanner/contactlg.jpg'
    },
]